import React, { useState, useEffect } from "react";
import {
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    Line,
    ComposedChart,
} from "recharts";
const monthMap = {
    '01': 'Jan',
    '02': 'Feb',
    '03': 'Mar',
    '04': 'Apr',
    '05': 'May',
    '06': 'Jun',
    '07': 'Jul',
    '08': 'Aug',
    '09': 'Sep',
    '10': 'Oct',
    '11': 'Nov',
    '12': 'Dec'
  };

const PlanStatusByMonth = () => {
    const [chartData, setChartData] = useState([]);

    useEffect(() => {
        fetch("https://malaria-api.ddc-malaria.org/mhealth/getChartOverallPlanStatusByMonthToday/fs_year")
            .then((response) => response.json())
            .then((data) => {
                const transformedData = Object.entries(
                    data.overall_plan_status_by_month_fiscal
                ).map(([monthKey, monthData]) => {
                    const { year_month, total_plan_detail } = monthData;
                    const monthYear = monthMap[year_month.slice(4)];

                    const {
                        total_plan,
                        total_cancel,
                        total_draft,
                        total_processing,
                        total_expire,
                        total_done,
                    } = total_plan_detail;

                    const percentComplete =
                        Math.round((total_done / total_plan) * 100) || 0; // Handle division by zero

                    return {
                        month: monthYear,
                        "percent Complete": percentComplete,
                        Draft: parseInt(total_draft, 10),
                        Cancel: parseInt(total_cancel, 10), // Assuming 'Active' corresponds to 'total_cancel'
                        Done: parseInt(total_done, 10),
                        Expire: parseInt(total_expire, 10), // Assuming 'Retired' corresponds to 'total_expire'
                        Processing: parseInt(total_processing, 10),
                    };
                });

                setChartData(transformedData);
            })
            .catch((error) => console.error("Error fetching data:", error));
    }, []);

    return (
        <div className="plan-status-by-month">
            <h3>Overall Plan Status by Month</h3>
            <ResponsiveContainer width="100%" height={300}>
                <ComposedChart data={chartData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis 
                        dataKey="month" 
                        tick={{ fontSize: 12 }} 
                        // Other props you might be using
                    />
                    <YAxis yAxisId="left" tick={{ fontSize: 12 }} /> {/* Add an ID for the left Y-axis */}
    <YAxis yAxisId="right" orientation="right" tick={{ fontSize: 12 }} /> {/* Add a right Y-axis */}
    
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="Draft" fill="#0088FE" barSize={40} yAxisId="left"/>
                    <Bar dataKey="Cancel" fill="#FF0000"barSize={40} yAxisId="left" />
                    <Bar dataKey="Done" fill="#008000" barSize={40} yAxisId="left"/>
                    <Bar dataKey="Expire" fill="#FFBB28"barSize={40} yAxisId="left" />
                    <Bar dataKey="Processing" fill="#00C49F" barSize={40} yAxisId="left"/>
                    <Line
                        type="monotone"
                        dataKey="percent Complete"
                        stroke="#3f51b5"
                        strokeWidth={1}
                        dot={true}
                        yAxisId="right" 
                        strokeDasharray="5 5"
                        label={{ position: 'top' , fontSize: 12,formatter: (value) => `${value}%`,fontWeight: 'bold'}} 
                    />
                </ComposedChart>
            </ResponsiveContainer>
        </div>
        /*
        <div className="plan-status-by-month">
            <h3>Overall Plan Status by Month</h3>
            <ResponsiveContainer width="100%" height={300}>
                <BarChart data={chartData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="month" tick={{ fontSize: 12 }}/>
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar dataKey="Draft" stackId="month" fill="#0088FE" />
                    <Bar dataKey="Cancel" stackId="month" fill="#FF0000" />
                    <Bar dataKey="Done" stackId="month" fill="#008000" />
                    <Bar dataKey="Expire" stackId="month" fill="#FFBB28" />
                    <Bar dataKey="Processing" stackId="month" fill="#00C49F" />
                    <Line
                        type="monotone"
                        dataKey="Percent Complete"
                        stroke="#3f51b5"
                        strokeWidth={3}
                        dot={false}
                    />
                </BarChart>
            </ResponsiveContainer>
        </div>
        */
    );
};

export default PlanStatusByMonth;

